import React from 'react';
import { Link } from 'react-scroll';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Mail } from 'lucide-react';

const Footer: React.FC = () => {
  const navigate = useNavigate();

  const handleServiceClick = (serviceName: string) => {
    if (serviceName === 'The First Impression Weapon: Hypnotic Hero Sections') {
      navigate('/products/hypnotic-hero-sections');
    } else if (serviceName === 'Conversion Copy Command') {
      navigate('/services/conversion-copy-command');
    } else if (serviceName === 'Apparel Arsenal: Clothing Design') {
      navigate('/services/apparel-arsenal');
    } else if (serviceName === 'Favicon Fingerprints') {
      navigate('/services/favicon-fingerprints');
    } else if (serviceName === 'Visual Warfare: Product Ad Design') {
      navigate('/services/visual-warfare');
    } else if (serviceName === 'Digital Doppelgänger') {
      navigate('/services/digital-doppelganger');
    } else if (serviceName === 'Shortform Ad Killshots') {
      navigate('/services/shortform-ad-killshots');
    } else if (serviceName === 'Revenue-Driven Digital Warfare:Brand Scaling & Profit Growth') {
      navigate('/services/revenue-digital-warfare');
    }
    // Add more service navigation here as you build more product pages
  };

  return (
    <footer className="relative bg-gradient-to-b from-stone-50 to-gray-100 border-t border-stone-200/50 py-16 px-6 overflow-hidden">
      {/* Texture overlay */}
      <div className="absolute inset-0 opacity-[0.02] bg-[radial-gradient(circle_at_1px_1px,_rgba(0,0,0,0.15)_1px,_transparent_0)] bg-[size:16px_16px]"></div>
      
      {/* Corner glow accents */}
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-radial from-lavender-200/20 via-transparent to-transparent opacity-30 blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-radial from-mint-200/20 via-transparent to-transparent opacity-30 blur-3xl"></div>
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center space-x-2 mb-6">
            <img
              src="/MI.png"
              alt="Manifest Illusions"
              className="w-6 h-6"
            />
            <span className="text-xl text-black italic font-serif">Manifest Illusions</span>
          </div>
          <p className="text-black mb-6 font-serif">
           It's not about being everywhere. It's about being unforgettable in the right places.
          </p>
          <div className="flex space-x-4">
            <a href="#" className="hover:opacity-80 transition-opacity" aria-label="Facebook">
              <svg className="w-6 h-6" fill="#1877F2" viewBox="0 0 24 24">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
            <a href="#" className="hover:opacity-80 transition-opacity" aria-label="Twitter">
              <svg className="w-6 h-6" fill="#000000" viewBox="0 0 24 24">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="#" className="hover:opacity-80 transition-opacity" aria-label="Instagram">
              <svg className="w-6 h-6" viewBox="0 0 24 24">
                <defs>
                  <linearGradient id="instagram-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" style={{stopColor: '#fdf497'}} />
                    <stop offset="5%" style={{stopColor: '#fdf497'}} />
                    <stop offset="45%" style={{stopColor: '#fd5949'}} />
                    <stop offset="60%" style={{stopColor: '#d6249f'}} />
                    <stop offset="90%" style={{stopColor: '#285AEB'}} />
                  </linearGradient>
                </defs>
                <path fill="url(#instagram-gradient)" d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947C23.728 2.695 21.31.273 16.948.073 15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
              </svg>
            </a>
            <a href="#" className="hover:opacity-80 transition-opacity" aria-label="LinkedIn">
              <svg className="w-6 h-6" fill="#0A66C2" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
          </div>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4 text-black font-serif">Services</h3>
          <ul className="space-y-2">
            <li>
              <button 
                onClick={() => handleServiceClick('Visual Warfare: Product Ad Design')}
                className="text-black hover:text-blue-400 transition-colors text-left font-serif"
              >
                Product Ad Photoshoot
              </button>
            </li>
            <li>
              <span className="text-black font-serif">
                Custom AI Chatbot
              </span>
            </li>
            <li>
              <button 
                onClick={() => handleServiceClick('Apparel Arsenal: Clothing Design')}
                className="text-black hover:text-blue-400 transition-colors text-left font-serif"
              >
                Clothing Design
              </button>
            </li>
            <li>
              <button 
                onClick={() => handleServiceClick('Digital Doppelgänger')}
                className="text-black hover:text-blue-400 transition-colors text-left font-serif"
              >
                Digital Doppelgänger
              </button>
            </li>
            <li>
              <button 
                onClick={() => handleServiceClick('Revenue-Driven Digital Warfare')}
                className="text-black hover:text-blue-400 transition-colors text-left font-serif"
              >
                Brand Scaling & Profit Growth
              </button>
            </li>
            <li>
              <button 
                onClick={() => handleServiceClick('Favicon Fingerprints')}
                className="text-black hover:text-blue-400 transition-colors text-left font-serif"
              >
                Logo & Favicon Fingerprints
              </button>
            </li>
            <li>
              <button 
                onClick={() => handleServiceClick('The First Impression Weapon: Hypnotic Hero Sections')}
                className="text-black hover:text-blue-400 transition-colors text-left font-serif"
              >
                Hypnotic
              </button>
            </li>
            <li>
              <button 
                onClick={() => handleServiceClick('Conversion Copy Command')}
                className="text-black hover:text-blue-400 transition-colors text-left font-serif"
              >
                Conversion Copy Command
              </button>
            </li>
            <li>
              <button 
                onClick={() => handleServiceClick('Shortform Ad Killshots')}
                className="text-black hover:text-blue-400 transition-colors text-left font-serif"
              >
             Cinematic Conversions
              </button>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4 text-black font-serif">Quick Links</h3>
          <ul className="space-y-2">
            <li>
              <Link
                to="home"
                smooth={true}
                duration={500}
                className="text-black hover:text-blue-400 transition-colors cursor-pointer font-serif"
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="services"
                smooth={true}
                duration={500}
                className="text-black hover:text-blue-400 transition-colors cursor-pointer font-serif"
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to="portfolio"
                smooth={true}
                duration={500}
                className="text-black hover:text-blue-400 transition-colors cursor-pointer font-serif"
              >
                Portfolio
              </Link>
            </li>
            <li>
              <Link
                to="why-us"
                smooth={true}
                duration={500}
                className="text-black hover:text-blue-400 transition-colors cursor-pointer font-serif"
              >
                Why Us
              </Link>
            </li>
            <li>
              <Link
                to="contact"
                smooth={true}
                duration={500}
                className="text-black hover:text-blue-400 transition-colors cursor-pointer font-serif"
              >
                Contact
              </Link>
            </li>
            <li>
              <RouterLink to="/privacy" className="text-black hover:text-blue-400 transition-colors font-serif">
                Privacy Policy
              </RouterLink>
            </li>
            <li>
              <RouterLink to="/terms" className="text-black hover:text-blue-400 transition-colors font-serif">
                Terms of Service
              </RouterLink>
            </li>
            <li>
              <RouterLink to="/cookies" className="text-black hover:text-blue-400 transition-colors font-serif">
                Cookie Policy
              </RouterLink>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4 text-black font-serif">Newsletter</h3>
          <p className="text-black mb-4 font-serif">
            Subscribe to our newsletter for the latest updates and offers.
          </p>
          <div className="space-y-4">
            <input
              type="email"
              placeholder="Your email address"
              className="w-full px-4 py-2 rounded-lg bg-white/80 border border-gray-300 text-black placeholder-gray-600 focus:border-blue-400 focus:outline-none font-serif"
              aria-label="Email address for newsletter"
            />
            <button className="w-full bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-all flex items-center justify-center space-x-2 font-serif">
              <Mail className="w-4 h-4 text-white" />
              <span className="text-white">Subscribe</span>
            </button>
            <p className="text-xs text-gray-600 font-serif">
              We respect your privacy. Unsubscribe at any time.
            </p>
          </div>
        </div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto mt-12 pt-8 border-t border-gray-800">
        <p className="text-center text-black font-serif">
          © {new Date().getFullYear()} Manifest Illusions. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;